export type Compound = { canonical_name: string; aliases: string[]; domains: string[] };

export const ALL_DOMAINS = ['cardiovascular', 'genomics', 'hormonal', 'neurological', 'gut', 'fitness', 'mental_health'];
export const DOMAIN_LABELS: Record<string, string> = {
  cardiovascular: 'Cardiovascular', genomics: 'Genomics', hormonal: 'Hormonal',
  neurological: 'Neurological', gut: 'Gut Health', fitness: 'Fitness', mental_health: 'Mental Health',
};
export const DOMAIN_HEX: Record<string, string> = {
  cardiovascular: '#F2635A', genomics: '#5B72E8', hormonal: '#D94080',
  neurological: '#F2A93B', gut: '#34C759', fitness: '#2BBAA8', mental_health: '#E54D8C',
};

